
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexqseWLffx2DfhQa4rH0iwNjzzn3_pEcU6DZhkfyq6fdkMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/index.vue?macro=true";
import { default as login6rK0pt2GWj8VkthmGl6TyqrF4YWhgZN5izgR9LmqoKgMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/login.vue?macro=true";
import { default as createN3winznphccs9IkiQEbfps_451kgR_45jmShBay43_45dBXuAMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/create.vue?macro=true";
import { default as forgotpxJ0CQJbmWWpE1YUjzdGRj1ecQPNuaa4ZPMDLS_jx0YMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/forgot.vue?macro=true";
import { default as reportsk6OMbzUFN7XLJS8N2wSiLrei2QTKXLFgDJGOEgg_Gc8Meta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/reports.vue?macro=true";
import { default as sign_45upgHR_45nOQVqr5S8c_wxYiSlUB3qLOZnq72uX8raO_457fnUMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/sign-up.vue?macro=true";
import { default as insights31UlxMi3Womy_ZX4ZlPiZ56ATElKNbFeFHDwMK1HBL8Meta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/insights.vue?macro=true";
import { default as newaKCuGbgUtljDVqi_458UPnguVWdaB6ORz5e2Me4P7AHeEMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/users/new.vue?macro=true";
import { default as newPRhqCwBFWd5v2YbDhACtb7_45N_4527f3V_edZUb8P7eTBoMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/makers/new.vue?macro=true";
import { default as newUCyqF51a4WYsETBZCTphS6XhSuenk49tdzehTPztfvgMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/orders/new.vue?macro=true";
import { default as _91id_93MBF9PtJPq_QD7Tk7xDNmnk2TkoVq4OxEAxX1WZSi1McMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/users/[id].vue?macro=true";
import { default as newOP_45Ur3pK1MbmmUoaFvzduM7mH41zRZ05pfcRgxB18jcMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/verify/new.vue?macro=true";
import { default as _91id_93s98EmlluuoN_YVQ1VvKMI9iTWkPMi7J_4541yTtUpqvAQMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/makers/[id].vue?macro=true";
import { default as newAu7Yo42TDwpRlZWnYCErv0dfUSnNcqKradpPdKSvpxIMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/rewards/new.vue?macro=true";
import { default as indexX6XQyb63kh5_G6D71jixWY8FRcHpSlZiqiU4zbzT7ccMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/users/index.vue?macro=true";
import { default as _91id_9394o0t6beoAbd4KuyiWZpPnyKSTVQ0l9EmjSTBu9w65cMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/verify/[id].vue?macro=true";
import { default as integrationssFlkTFgsxVmQ4Gx92r_okJaNvLy4kVzzI32HoT_45C9fcMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/integrations.vue?macro=true";
import { default as indexGT3vkWpiMsS7PG71_KgliHpJ2_45IpGyp20u2t7yL8bqYMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/makers/index.vue?macro=true";
import { default as indexz7_45BjGYrS0qkJnvMzKaVFfGhrZ6kziE0sF3LmlObbvgMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/orders/index.vue?macro=true";
import { default as newjf5R2p0W1_9NQc_45iKd_45KF__45WlprZFbg5aoxM5o_h6PkMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/packages/new.vue?macro=true";
import { default as newNLnmxu2MaebyoaaC11qV2SiKr3DxpJ9WKKKOoTo2FQ0Meta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/products/new.vue?macro=true";
import { default as indexm1tYt0dNfXwlHtYGVF5E6TO_45rrtFIiEaJOFuBheWRqkMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/queues/index.vue?macro=true";
import { default as _91id_93iNPT2GxVcoGaiRYb7nE0FmpnPcyR9DrQ0NWpVcmB0IgMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/rewards/[id].vue?macro=true";
import { default as new9we0wkxAPL5d9aEyDr7mih__45UJvduFXAsSe9jo64GrIMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/settings/new.vue?macro=true";
import { default as newbMRuYp9FOuGSI6R7g3IyHox7PoS0CCI8QusAnkgE1d4Meta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/discounts/new.vue?macro=true";
import { default as _91id_93ZPENxbuvuZReebrz1tKh9uOc9j3zLgACTd6_PZpJdEYMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/packages/[id].vue?macro=true";
import { default as _91id_93g4LlWu96WatCBdy7QVXE1wpHYQnTyBvWdSyFp9Cqh0sMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/password/[id].vue?macro=true";
import { default as _91id_93GHOSV3nvmuEK7vFDF9W1muSKVXcF80_457emTodirTbgkMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/products/[id].vue?macro=true";
import { default as indexfhbpXS28_UGLCKvkPe7wtf9pq5VdQk1C6kQJ9lTWLLYMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/rewards/index.vue?macro=true";
import { default as _91id_931Uxj0vtdyjji83K1xPTNCBgx5MzIoAtuvcNWbHtg0HMMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/settings/[id].vue?macro=true";
import { default as _91id_93GmL7G_hbAs_45n57r_45FUjgPV3_454NHx9B81Ra8ddPRF2wEMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/customers/[id].vue?macro=true";
import { default as _91id_93srP_45QJUVjn0Rd_459MG4pA1PwtralAUyIrGmbmhexmCY4Meta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/discounts/[id].vue?macro=true";
import { default as downloadULu2ckoi2E_g_URz3wltqLEMWw_XivJpGNiNly6CPbUMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/files/download.vue?macro=true";
import { default as indexPhMnT5rWCNl8zwOREzQLcyQMy7xrAo5ok3H7ScCAvtMMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/packages/index.vue?macro=true";
import { default as indexaR0kLlNASgv9E4URIOZkSRwjFOq0NykAzkSQK6KV7WAMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/products/index.vue?macro=true";
import { default as indexaC_GDta5mVoES0a6_45h0Lb_45fDrM_Z6G1CXQzoxXJ_egMMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/settings/index.vue?macro=true";
import { default as newDeeiWK_45SYoaPv0utDShHEpIjvC3NP0LQ80TBhdIoWFUMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/cost-centre/new.vue?macro=true";
import { default as indexvXfw7JxzT9Gu84iPItXGx1W0WC691sonnAwh4sGgfv4Meta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/customers/index.vue?macro=true";
import { default as indexsq_CIhr5jUEpIowitgsYCUdS6EnZIvl2_458YVwFzgxLcMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/discounts/index.vue?macro=true";
import { default as _91id_93cSgE6IuqylWuMd7UvOtsN3hMrOG0sjz5uKsT75i2aOMMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/cost-centre/[id].vue?macro=true";
import { default as index7AU942Z9KKZbQslycoQ4L5cTpNYXtZraht67nix7e1UMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/cost-centre/index.vue?macro=true";
import { default as indexEqQubR_vaxxdJFWFs9cp3OmW5s_TEhY_dLIkVQQYbsUMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/orders/[id]/index.vue?macro=true";
import { default as newr06k95u6zewAfOMTgWLmx0ifOYP9S2j1zU5N50MYzWgMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/organisations/new.vue?macro=true";
import { default as _91id_93IQYjd85f8R7NTpsOY5JA6CQPKJd2dfyJkgkq9IIy734Meta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/organisations/[id].vue?macro=true";
import { default as indexp7f7y2eZ2rwS5hIf4CdKn3SaAz9Kfv31XAzWhCTFQGkMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/organisations/index.vue?macro=true";
import { default as new_GWbQWHtN_boEAFiK5ovcf4qQFdktAZmObxdhPjK8R8Meta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/maker-categories/new.vue?macro=true";
import { default as _91id_93WCJ9ShkZuMalSWk7ZlCCXsmqmkK_3ecqxA6HhWf3OHYMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/maker-categories/[id].vue?macro=true";
import { default as indexh5PBl0aAXPNd5yDNxG_1j4K31XAFCW4LekY4ZowlQmAMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/maker-categories/index.vue?macro=true";
import { default as newxaB2ZcJKtGOTu9I6hwZ9ISudt8COH_45OlOv_AcrqqRgAMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/product-categories/new.vue?macro=true";
import { default as _91id_93KtW1SIxlG3vEdbVGslkCPKiyd5UyYgNpzDFszZHNotsMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/product-categories/[id].vue?macro=true";
import { default as index2n_7Uohf4Su1BLsV3zm8XpnaNaB8DDpes2eK1rPm_QUMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/product-categories/index.vue?macro=true";
import { default as _91id_9329IwqWvvz6y_Rmx1zjKzNpX4nsE70JRXxfS996ej2RYMeta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/settings/subConfigs/[id].vue?macro=true";
import { default as transaction_45historyGnA8JjvKZIRrL23oEnXsmZH9AxBqRoJMR3UQEtmtD48Meta } from "/codebuild/output/src1847072966/src/and-dine-hub/pages/orders/[id]/transaction-history.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/login.vue")
  },
  {
    name: "create",
    path: "/create",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/create.vue")
  },
  {
    name: "forgot",
    path: "/forgot",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/forgot.vue")
  },
  {
    name: "reports",
    path: "/reports",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/reports.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/sign-up.vue")
  },
  {
    name: "insights",
    path: "/insights",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/insights.vue")
  },
  {
    name: "users-new",
    path: "/users/new",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/users/new.vue")
  },
  {
    name: "makers-new",
    path: "/makers/new",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/makers/new.vue")
  },
  {
    name: "orders-new",
    path: "/orders/new",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/orders/new.vue")
  },
  {
    name: "users-id",
    path: "/users/:id()",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/users/[id].vue")
  },
  {
    name: "verify-new",
    path: "/verify/new",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/verify/new.vue")
  },
  {
    name: "makers-id",
    path: "/makers/:id()",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/makers/[id].vue")
  },
  {
    name: "rewards-new",
    path: "/rewards/new",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/rewards/new.vue")
  },
  {
    name: "users",
    path: "/users",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/users/index.vue")
  },
  {
    name: "verify-id",
    path: "/verify/:id()",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/verify/[id].vue")
  },
  {
    name: "integrations",
    path: "/integrations",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/integrations.vue")
  },
  {
    name: "makers",
    path: "/makers",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/makers/index.vue")
  },
  {
    name: "orders",
    path: "/orders",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/orders/index.vue")
  },
  {
    name: "packages-new",
    path: "/packages/new",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/packages/new.vue")
  },
  {
    name: "products-new",
    path: "/products/new",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/products/new.vue")
  },
  {
    name: "queues",
    path: "/queues",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/queues/index.vue")
  },
  {
    name: "rewards-id",
    path: "/rewards/:id()",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/rewards/[id].vue")
  },
  {
    name: "settings-new",
    path: "/settings/new",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/settings/new.vue")
  },
  {
    name: "discounts-new",
    path: "/discounts/new",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/discounts/new.vue")
  },
  {
    name: "packages-id",
    path: "/packages/:id()",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/packages/[id].vue")
  },
  {
    name: "password-id",
    path: "/password/:id()",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/password/[id].vue")
  },
  {
    name: "products-id",
    path: "/products/:id()",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/products/[id].vue")
  },
  {
    name: "rewards",
    path: "/rewards",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/rewards/index.vue")
  },
  {
    name: "settings-id",
    path: "/settings/:id()",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/settings/[id].vue")
  },
  {
    name: "customers-id",
    path: "/customers/:id()",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/customers/[id].vue")
  },
  {
    name: "discounts-id",
    path: "/discounts/:id()",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/discounts/[id].vue")
  },
  {
    name: "files-download",
    path: "/files/download",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/files/download.vue")
  },
  {
    name: "packages",
    path: "/packages",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/packages/index.vue")
  },
  {
    name: "products",
    path: "/products",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/products/index.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/settings/index.vue")
  },
  {
    name: "cost-centre-new",
    path: "/cost-centre/new",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/cost-centre/new.vue")
  },
  {
    name: "customers",
    path: "/customers",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/customers/index.vue")
  },
  {
    name: "discounts",
    path: "/discounts",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/discounts/index.vue")
  },
  {
    name: "cost-centre-id",
    path: "/cost-centre/:id()",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/cost-centre/[id].vue")
  },
  {
    name: "cost-centre",
    path: "/cost-centre",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/cost-centre/index.vue")
  },
  {
    name: "orders-id",
    path: "/orders/:id()",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/orders/[id]/index.vue")
  },
  {
    name: "organisations-new",
    path: "/organisations/new",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/organisations/new.vue")
  },
  {
    name: "organisations-id",
    path: "/organisations/:id()",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/organisations/[id].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/organisations/index.vue")
  },
  {
    name: "maker-categories-new",
    path: "/maker-categories/new",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/maker-categories/new.vue")
  },
  {
    name: "maker-categories-id",
    path: "/maker-categories/:id()",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/maker-categories/[id].vue")
  },
  {
    name: "maker-categories",
    path: "/maker-categories",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/maker-categories/index.vue")
  },
  {
    name: "product-categories-new",
    path: "/product-categories/new",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/product-categories/new.vue")
  },
  {
    name: "product-categories-id",
    path: "/product-categories/:id()",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/product-categories/[id].vue")
  },
  {
    name: "product-categories",
    path: "/product-categories",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/product-categories/index.vue")
  },
  {
    name: "settings-subConfigs-id",
    path: "/settings/subConfigs/:id()",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/settings/subConfigs/[id].vue")
  },
  {
    name: "orders-id-transaction-history",
    path: "/orders/:id()/transaction-history",
    component: () => import("/codebuild/output/src1847072966/src/and-dine-hub/pages/orders/[id]/transaction-history.vue")
  }
]